import { render, staticRenderFns } from "./BaseInputCheckbox.vue?vue&type=template&id=1a2f64c1&scoped=true&"
import script from "./BaseInputCheckbox.vue?vue&type=script&lang=js&"
export * from "./BaseInputCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputCheckbox.vue?vue&type=style&index=0&id=1a2f64c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2f64c1",
  null
  
)

export default component.exports